<template><div><h1 id="ereignisstatus" tabindex="-1"><a class="header-anchor" href="#ereignisstatus"><span>Ereignisstatus</span></a></h1>
<p>Ereignisstatus — Definition der Ereignistati</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Tabelle definiert den Ereignisstatus für die Erfassung von Ereignissen (Kundengeschichte). Bei Refusé-Ereignissen wird zusätzlich noch eine Kategorie für die Zuordnung der verschiedenen Refusé-Typen definiert.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Ereignisstatus</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Status</dt>
<dd>Ereignisstatus</dd>
<dt>Typ</dt>
<dd>Ereignistyp</dd>
<dt>Kategorie</dt>
<dd>Ereigniskategorie</dd>
<dt>Beschreibung</dt>
<dd>Nähere Beschreibung</dd>
<dt>mögliche Situationen</dt>
<dd>Ereignissituationen</dd>
<dt>manuelle Erfassung</dt>
<dd>Situationen, in der eine manuelle Erfassung erlaubt wird</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionen</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.ereignisse.html" title="Personenereignisse">Ereignisse</RouteLink></p>
</div></template>


